var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmiCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3246 13.247H5.14355C4.77214 13.247 4.46826 12.9431 4.46826 12.5717V3.79297C4.46826 3.42156 4.77214 3.11768 5.14355 3.11768H19.3246C19.696 3.11768 19.9999 3.42156 19.9999 3.79297V12.5717C19.9999 12.9431 19.696 13.247 19.3246 13.247Z",
    fill: "#2978B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46826 5.14355H19.9999V7.16942H4.46826V5.14355Z",
    fill: "#B6B9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2729 17.2988H1.09179C0.720384 17.2988 0.416504 16.9949 0.416504 16.6235V7.84472C0.416504 7.47331 0.720384 7.16943 1.09179 7.16943H15.2729C15.6443 7.16943 15.9482 7.47331 15.9482 7.84472V16.6235C15.9482 16.9949 15.6443 17.2988 15.2729 17.2988Z",
    fill: "#3397E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76709 9.87036H3.79296V11.2209H1.76709V9.87036Z",
    fill: "#F7B030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44238 16.2861H1.76709C1.58138 16.2861 1.42944 16.1342 1.42944 15.9485C1.42944 15.7628 1.58138 15.6108 1.76709 15.6108H2.44238C2.62808 15.6108 2.78002 15.7628 2.78002 15.9485C2.78002 16.1342 2.62808 16.2861 2.44238 16.2861Z",
    fill: "#2978B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16942 16.2861H3.79297C3.60726 16.2861 3.45532 16.1342 3.45532 15.9485C3.45532 15.7628 3.60726 15.6108 3.79297 15.6108H7.16942C7.35512 15.6108 7.50706 15.7628 7.50706 15.9485C7.50706 16.1342 7.35512 16.2861 7.16942 16.2861Z",
    fill: "#2978B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11767 12.9094H1.76709C1.58138 12.9094 1.42944 12.7575 1.42944 12.5718C1.42944 12.3861 1.58138 12.2341 1.76709 12.2341H3.11767C3.30337 12.2341 3.45531 12.3861 3.45531 12.5718C3.45531 12.7575 3.30337 12.9094 3.11767 12.9094Z",
    fill: "#2978B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81884 12.9094H4.46826C4.28256 12.9094 4.13062 12.7575 4.13062 12.5718C4.13062 12.3861 4.28256 12.2341 4.46826 12.2341H5.81884C6.00454 12.2341 6.15648 12.3861 6.15648 12.5718C6.15648 12.7575 6.00454 12.9094 5.81884 12.9094Z",
    fill: "#2978B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52001 12.9094H7.16943C6.98373 12.9094 6.83179 12.7575 6.83179 12.5718C6.83179 12.3861 6.98373 12.2341 7.16943 12.2341H8.52001C8.70572 12.2341 8.85766 12.3861 8.85766 12.5718C8.85766 12.7575 8.70572 12.9094 8.52001 12.9094Z",
    fill: "#2978B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2212 12.9094H9.8706C9.6849 12.9094 9.53296 12.7575 9.53296 12.5718C9.53296 12.3861 9.6849 12.2341 9.8706 12.2341H11.2212C11.4069 12.2341 11.5588 12.3861 11.5588 12.5718C11.5588 12.7575 11.4069 12.9094 11.2212 12.9094Z",
    fill: "#2978B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79296 8.85815H1.76709C1.58138 8.85815 1.42944 8.70621 1.42944 8.52051C1.42944 8.3348 1.58138 8.18286 1.76709 8.18286H3.79296C3.97866 8.18286 4.1306 8.3348 4.1306 8.52051C4.1306 8.70621 3.97866 8.85815 3.79296 8.85815Z",
    fill: "#2978B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5976 8.85766H12.5718C12.3861 8.85766 12.2341 8.70572 12.2341 8.52002C12.2341 8.33431 12.3861 8.18237 12.5718 8.18237H14.5976C14.7834 8.18237 14.9353 8.33431 14.9353 8.52002C14.9353 8.70572 14.7834 8.85766 14.5976 8.85766Z",
    fill: "#2978B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.26 16.2856H12.9094C12.538 16.2856 12.2341 15.9818 12.2341 15.6103C12.2341 15.2389 12.538 14.9351 12.9094 14.9351H14.26C14.6314 14.9351 14.9353 15.2389 14.9353 15.6103C14.9353 15.9818 14.6314 16.2856 14.26 16.2856Z",
    fill: "#DADCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3118 12.2339H16.9612C16.5898 12.2339 16.2859 11.93 16.2859 11.5586C16.2859 11.1872 16.5898 10.8833 16.9612 10.8833H18.3118C18.6832 10.8833 18.987 11.1872 18.987 11.5586C18.987 11.93 18.6832 12.2339 18.3118 12.2339Z",
    fill: "#DADCDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmiCard);
export default __webpack_public_path__ + "static/media/EMICard.f2e64eee20100c95547080c828973805.svg";
export { ForwardRef as ReactComponent };